import React from "react";
import Image from "next/image";
import { configuration } from "../../helpers/config";
import { formatCurrency ,IsValidPrice} from "../../utils/GenUtils";
import ReactPlayer from "react-player";
import { Constants } from "../../helpers/constants";
import useWindowSize from "../../hooks/useWindowSize";
import { useEffect } from "react";

// component to display banner Image/ Video on brand pages and other pages
export default function BrandBanner({
  banners,
  videoUrl,
  mobvideoUrl,
  modelName,
  retailPrice,
  themeSetting,
  bannerfirstPrice,
  bannersecondPrice,
  bannerthirdPrice,
  bannerfirstPriceText,
  bannersecondPriceText,
  bannerthirdPriceText,
  isPriceLoaded
}) {
  const windoWidth = useWindowSize();
  return (
    <>
      <div className="relative brand__banner" id="top">
        <div className="block md:hidden mobile_banner">
          {/* <video
            className="video-background"
            autoPlay
            loop
            muted
            playsInline
            src={`${configuration.IMG_URL}${videoUrl}`}
          /> */}
          {mobvideoUrl ? (
            <ReactPlayer
              url={ mobvideoUrl? `${configuration.IMG_URL}${mobvideoUrl}` : "" }
              playing={true}
              volume={0}
              height="100%"
              width="100%"
              loop={true}
              playsinline
            />
          ) : (
            <Image
              src={ banners?.mob_banners[0]?  `${configuration.IMG_URL}${banners?.mob_banners[0]}` : "" }
              // layout="fill"
              // objectFit="cover"
              alt={banners?.mob_banner_alt}
              height={1080}
              width={768}
            />
          )}
        </div>

        <div className="hidden md:block">
          {videoUrl ? (
            <ReactPlayer
              url={ videoUrl? `${configuration.IMG_URL}${videoUrl}` : ""}
              playing={true}
              volume={0}
              height={"100vh"}
              width={"100%"}
              loop={true}
              playsinline
            />
          ) : (
            <Image
              src={banners?.desk_banners[0] ? `${configuration.IMG_URL}${banners?.desk_banners[0]}` : "" }
              alt={banners?.desk_banner_alt}
              height={1004}
              width={1928}
            />
          )}
        </div>

        <div className="container mx-auto ">
          <div className="brand__banner--position">
            <h1
              className={`uppercase font-suzukiBold text-heading42 md:text-bannerHeading lg:text-[${themeSetting?.model_title_font_size}] text-inverted mb-[5px] md:mb-0 lg:mb-[0] xl:mb-[0px]`}
              style={
                windoWidth.width > 1024
                  ? {
                      fontSize: themeSetting?.model_title_font_size,
                      color: themeSetting?.model_title_color,
                    }
                  : { color: themeSetting?.model_title_color }
              }
            >
              {modelName}
            </h1>
            <div className="brand__banner--model_info">
              {/* first price */}
              {isPriceLoaded && IsValidPrice(bannerfirstPrice) && bannerfirstPrice>0 && bannerfirstPriceText ? (
                <p
                  style={
                    windoWidth.width > 1024
                      ? {
                          fontSize: themeSetting?.model_price_font_size,
                          color: themeSetting?.model_price_color,
                        }
                      : { color: themeSetting?.model_price_color }
                  }
                >
                  {/* {Constants.brandPage.BRAND_BANNER_PRICE}{" "}
                  {isPriceLoaded && IsValidPrice(bannerfirstPrice) && bannerfirstPrice> 0
                    ? `${formatCurrency(bannerfirstPrice)}`
                    : "NA"} */}
                    {configuration?.COUNTRY_CODE!="HUN"?Constants.brandPage.BRAND_BANNER_PRICE:""}{" "}
                  {isPriceLoaded && IsValidPrice(bannerfirstPrice) && bannerfirstPrice> 0
                    ? `${formatCurrency(bannerfirstPrice)}${configuration?.COUNTRY_CODE=="HUN"?"-"+Constants.brandPage.BRAND_BANNER_PRICE:""}`
                    : "NA"}
                  <small
                    style={
                      windoWidth.width > 1024
                        ? {
                            fontSize: themeSetting?.model_price_title_font_size,
                            color: themeSetting?.model_price_title_color,
                          }
                        : { color: themeSetting?.model_price_title_color }
                    }
                    // style={{color: themeSetting?.model_price_title_color}}
                  >
                    {bannerfirstPriceText}
                  </small>
                </p>
              ) : null}
              {/*TOD0: Uncomment this code when the API is ready, Meanwhile don't remove and wait for approvals*/}
              {/* <p>
               1000
               <small>Mileage</small>
              </p>
              <p>
               2000
               <small>Fuel Type</small>
              </p> */}

              {/* second price */}
              {isPriceLoaded && IsValidPrice(bannersecondPrice) && bannersecondPrice> 0 && bannersecondPriceText ? (
                <p
                  style={
                    windoWidth.width > 1024
                      ? {
                          fontSize: themeSetting?.model_price_font_size,
                          color: themeSetting?.model_price_color,
                        }
                      : { color: themeSetting?.model_price_color }
                  }
                >
                   {configuration?.COUNTRY_CODE!="HUN"?Constants.brandPage.BRAND_BANNER_PRICE:""}{" "}
                  {isPriceLoaded && IsValidPrice(bannersecondPrice)  && bannersecondPrice > 0
                    ? `${formatCurrency(bannersecondPrice)}${configuration?.COUNTRY_CODE=="HUN"?"-"+Constants.brandPage.BRAND_BANNER_PRICE:""}`
                    : "NA"}
                  <small
                    style={
                      windoWidth.width > 1024
                        ? {
                            fontSize: themeSetting?.model_price_title_font_size,
                            color: themeSetting?.model_price_title_color,
                          }
                        : { color: themeSetting?.model_price_title_color }
                    }
                    // style={{color: themeSetting?.model_price_title_color}}
                  >
                    {bannersecondPriceText}
                  </small>
                </p>
              ) : null}
              {/* third price */}
              {isPriceLoaded && IsValidPrice(bannerthirdPrice) && bannerthirdPrice>0 && bannerthirdPriceText ? (
                <p
                  style={
                    windoWidth.width > 1024
                      ? {
                          fontSize: themeSetting?.model_price_font_size,
                          color: themeSetting?.model_price_color,
                        }
                      : { color: themeSetting?.model_price_color }
                  }
                >
                  {configuration?.COUNTRY_CODE!="HUN"?Constants.brandPage.BRAND_BANNER_PRICE:""}{" "}
                  {isPriceLoaded && IsValidPrice(bannerthirdPrice) &&  bannerthirdPrice > 0
                    ? `${formatCurrency(bannerthirdPrice)}${configuration?.COUNTRY_CODE=="HUN"?"-"+Constants.brandPage.BRAND_BANNER_PRICE:""}`
                    : "NA"}
                  <small
                    style={
                      windoWidth.width > 1024
                        ? {
                            fontSize: themeSetting?.model_price_title_font_size,
                            color: themeSetting?.model_price_title_color,
                          }
                        : { color: themeSetting?.model_price_title_color }
                    }
                    // style={{color: themeSetting?.model_price_title_color}}
                  >
                    {bannerthirdPriceText}
                  </small>
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
